import { render, staticRenderFns } from "./LnfraredLnductor.vue?vue&type=template&id=5a2e4490&scoped=true"
import script from "./LnfraredLnductor.vue?vue&type=script&lang=js"
export * from "./LnfraredLnductor.vue?vue&type=script&lang=js"
import style0 from "./LnfraredLnductor.vue?vue&type=style&index=0&id=5a2e4490&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a2e4490",
  null
  
)

export default component.exports